import { AppProvider as PolarisProvider, Frame } from '@shopify/polaris';
// tslint:disable-next-line: no-submodule-imports
import translations from '@shopify/polaris/locales/en.json';
import { useEffect, useState } from 'react';
import { BrowserRouter as Router, Link as ReactRouterLink, useNavigate } from 'react-router-dom';
import {init} from '../services/sentryInit';
import { Routes } from './routes'

const LinkComponent = (props: any) => {
  const nav = useNavigate();
  const { children, url, external, ...rest } = props;

  if (external) {
    return (
      <a href={url} target="_blank" rel="noopener noreferrer" {...rest}>
        {children}
      </a>
    );
  }

  return (
    <div {...rest} onClick={()=> nav(url)}>
      {children}
    </div>
  );
};

// Replacement of App Bridge v3 forceRedirect: open the app inside Shopify admin if loaded outside of iframe
function redirectToAdminIfNeeded(apiKey: string): boolean {
  if (window.top !== window.self) {
    return false;
  }

  // @ts-ignore
  const host = new URL(location).searchParams.get('host');

  if (!host) {
    return false;
  }

  window.location.assign(`https://${atob(host)}/apps/${apiKey}${location.pathname}`);
  return true;
}

export default function App() {
  const [apiKey, setApiKey] = useState(null);
  
  useEffect(()=>{
    async function fetchData() {
      try {
        const res = await fetch('/get_app_data');
        const data = await res.json();
        if (redirectToAdminIfNeeded(data.apiKey)) {
          return;
        }

        setApiKey(data.apiKey);
        init(data.sentryDsn);
      } catch (e) {
        // tslint:disable-next-line:no-console
        console.error('error', e);
      }
    }

    fetchData();
  }, []);
  
  return (
    <PolarisProvider i18n={translations} linkComponent={LinkComponent}>
      {apiKey ?
        <Frame>
          <Router>
            <Routes />
          </Router>
        </Frame>
        : <></>
      }
    </PolarisProvider>
  );
}
